<div class="centerMatCardTitle">
  <h1
    class="title-heading"
    data-test="title-current-clients"
    [ngClass]="{ 'iris-h1-desktop': !breakPoint.isMobile, 'iris-h1-mobile': breakPoint.isMobile }"
    tabindex="0"
    data-dd-privacy="allow"
  >
    Clients
  </h1>

  <div
    class="sondermind-design-system header-actions"
    data-dd-privacy="allow"
  >
    <div class="button-group">
      <iris-button
        [buttonType]="buttonType"
        (click)="handleNewPatientClick()"
        data-test="clients-invite-client"
      >{{ addButtonText }}
      </iris-button>

      <iris-button
        *ngIf="showBulkUploadButton"
        [buttonType]="IrisButtonTypes.SECONDARY"
        (click)="handleBulkUploadClick()"
        data-test="clients-bulk-upload"
      >Upload clients
      </iris-button>
    </div>

    <div class="client-invite-mobile" (click)="handleNewPatientClick()">
      <a class="client-invite-mobile-link">
        {{ addButtonText }}
      </a>
      <button mat-fab class="client-invite-mobile-button">
        <iris-icon name="plus" [size]="iconSizes.MD"></iris-icon>
      </button>
    </div>
  </div>
</div>

<ng-container *ngIf="paginationData.total > 0">
  <div class="client-search">
    <div class="client-search-container" data-dd-privacy="mask">
      <client-search-bar
        [filters]="filterOptions.filter"
      ></client-search-bar>
    </div>
    <div class="client-sort-container">
      <h4 class="client-search-header">Sort by</h4>
      <form [formGroup]="sortForm">
        <iris-form-field [showOptionalTag]="false">
          <iris-dropdown
            [options]="sortOptions"
            formControlName="sortFormControl"
          >
          </iris-dropdown>
        </iris-form-field>
      </form>
    </div>
  </div>
  <div class="filters">
    <form [formGroup]="sortForm" class="sort-form">
      <iris-form-field [showOptionalTag]="false">
        <iris-dropdown 
          [options]="sessionOptions" 
          formControlName="sessionFormControl" 
          data-test="session-time-filter-select"
        ></iris-dropdown>
      </iris-form-field>

      <iris-form-field [showOptionalTag]="false">
        <iris-dropdown 
          [options]="clientStatusOptions" 
          formControlName="clientStatusFormControl" 
          data-test="current-client-filter-select"
        ></iris-dropdown>
      </iris-form-field>
    </form>
    <iris-button
      [buttonType]="IrisButtonTypes.TERTIARY"
      (click)="clearFilters()"
      aria-label="Clear filters"
      data-test="clear-clients-filters"
      role="menuitem"
    >
      Clear filters
    </iris-button>
  </div>
  <hr class="after-filters">
</ng-container>

<section
  class="client-list"
  [ngClass]="{'ascending-arrow': tableState.sortAscending, 'descending-arrow': !tableState.sortAscending}"
>
  <div [hidden]="clients.length === 0">
    <mat-table
      [@.disabled]="true"
      #table
      [dataSource]="clients"
      matSort
      [matSortActive]="tableState.sortBy"
      [matSortStart]="'asc'"
      data-test="current-clients-table"
      data-dd-privacy="allow"
    >
      <ng-container matColumnDef="last_name">
        <mat-header-cell
          class="pad3 client-list-header"
          mat-sort-header
          *matHeaderCellDef
          disableClear="true"
          data-test="current-clients-name-sort"
          [ngClass]="{ 'sorted-header': tableState.sortBy === 'last_name' }"
        >
          Name
        </mat-header-cell>
        <mat-cell
          class="pad3 client-list-detail"
          *matCellDef="let row"
          data-test="current-client-name"
          (click)="viewClient(row)"
        >
          <div class="name-row">
            <div
              class="name-container"
              tabindex="0"
            >
              <span
                data-dd-privacy="mask"
                [attr.data-dd-action-name]="'client #' + row.patientId"
              >
                {{ row.displayName }}
              </span>
            </div>
            <div
              *ngIf="row.inactiveClient"
              [ngClass]="row.statusClass"
              class="client-status-flags"
              tabindex="0"
            >
              <sonder-tooltip desktopTooltipText="Inactive" >
                <div displayText>{{ row.clientStatus | titlecase }}</div>
              </sonder-tooltip>
            </div>
            <div
              *ngIf="!row.allowScheduling"
              class="client-status-flags"
              data-test="suspended-account-icon"
              tabindex="0"
            >
            <sonder-tooltip [desktopTooltipText]="(row.patient ? row.patient.displayName : row.displayName) + ' has payments due and cannot be scheduled until they pay their bills.'" >
                <iris-icon
                displayText
                name="warning"
                [usage]="IconUsageTypes.DECORATIVE"
                [size]="IconSizes.MD"
                [color]="IconColors.DANGER"
              ></iris-icon>
            </sonder-tooltip>
              
            </div>
            <div
              *ngIf="row.invitedClient"
              [ngClass]="row.statusClass"
              class="client-status-flags"
              tabindex="0"
            >
            <sonder-tooltip desktopTooltipText="Invited" >
              <div displayText>Invited</div>
            </sonder-tooltip>
            </div>
            <div
              *ngIf="row.clientUnderage"
              class="client-status-flags"
              tabindex="0"
            >
            <sonder-tooltip desktopTooltipText="Minor" >
              <div displayText>
                <img alt="Minor" src="/assets/images/clients-list/minor-tag.svg"/>
              </div>
            </sonder-tooltip>
            </div>
            <div
              *ngIf="!row.accountComplete"
              class="client-status-flags"
              data-test="incomplete-account-icon"
              tabindex="0"
            >
            <sonder-tooltip desktopTooltipText="Incomplete Account" >
              <div displayText>
                <img alt="Incomplete Account" src="/assets/images/clients-list/incomplete-account-tag.svg"/>
              </div>
            </sonder-tooltip>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="next_session_datetime">
        <mat-header-cell
          class="client-list-header"
          mat-sort-header
          *matHeaderCellDef
          disableClear="true"
          data-test="current-client-next-session-sort"
          [ngClass]="{ 'sorted-header': tableState.sortBy === 'next_session_datetime' }"
        >
          Upcoming session
        </mat-header-cell>
        <mat-cell
          class="pad2 client-list-detail"
          *matCellDef="let row"
          data-test="current-client-next-appointment"
          (click)="viewClient(row)"
        >
          <div class="session-row">
            <ng-container *ngIf="row.lastSessionDateTime || row.nextSessionDateTime">
              <a
                *ngIf="row.nextSessionDateTime"
                [routerLink]="['/scheduling', 'events', row.nextSessionId]"
                aria-label="Upcoming session"
                data-test="upcoming-appointment-link"
                class="upcoming-appointment-link"
              >
                {{ row.nextSessionDateTime | localizedDate:'weekday' }},
                {{ row.nextSessionDateTime | localizedDate:{ month: 'short', day: 'numeric' } }}
                <span *ngIf="!breakPoint.isMobile">,</span>
                <br *ngIf="breakPoint.isMobile">
                {{ row.nextSessionDateTime | localizedDate:'shortTime' | lowercase }} -
                {{ row.nextSessionEndTime | localizedDate:'shortTime' | lowercase }}
              </a>
              <a
                *ngIf="!row.nextSessionDateTime && this.breakPoint.isMobile"
                gtagCtaEvent
                aria-label="Schedule"
                class="upcoming-appointment-link"
                [routerLink]="['/scheduling', 'events', 'new']"
                [queryParams]="{ patientId: row.isPatientRecord ? row.id : null }"
                data-test="schedule-session-mobile"
              > Schedule
              </a>
              <ng-container *sondermindFeatureFlag="'providerRecurringIconClientList'">
                <span
                  *ngIf="row.recurringUntil"
                  class="recurring-until-icon"
                >
                <sonder-tooltip [desktopTooltipText]="'Repeats until ' + (row.recurringUntil | localizedDate:{ month: '2-digit', day: 'numeric' })">
                    <iris-icon
                      displayText
                      name="calendar_recurring"
                      [usage]="IconUsageTypes.STAND_ALONE"
                      [color]="IconColors.BRAND1"
                      [size]="IconSizes.SM" >
                    </iris-icon>
                </sonder-tooltip>
                </span>
              </ng-container>
            </ng-container>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="days_since_last_session">
        <mat-header-cell
          class="pad3 client-list-header"
          mat-sort-header
          *matHeaderCellDef
          disableClear="true"
          [ngClass]="{
              'sorted-header': tableState.sortBy === 'days_since_last_session',
              'hidden-column-mobile': breakPoint.isMobile
            }"
          data-test="current-clients-last-session-sort"
        >
          Days since last session
        </mat-header-cell>
        <mat-cell
          class="pad3 client-list-detail"
          *matCellDef="let row"
          [ngClass]="{ 'hidden-column-mobile': breakPoint.isMobile }"
          data-test="current-client-days-since-last-session"
          (click)="viewClient(row)"
        >
        <div class="days-since-column">
          <div
            id="daysSinceLast"
            class="days-since-content"
            tabindex="0"
          >{{ displayDaysSinceLastSession(row.daysSinceLastSession) }}</div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell
          [ngClass]="{ 'hidden-column-mobile': breakPoint.isMobile }"
          class="pad3 client-list-header"
          *matHeaderCellDef
          disableClear="true"
          data-test="current-clients-last-actions"
          tabindex="0"
        >
          Actions
        </mat-header-cell>
        <mat-cell
          [ngClass]="{ 'hidden-column-mobile': breakPoint.isMobile }"
          class="pad3 client-list-detail"
          *matCellDef="let row"
          data-test="current-clients-last-action"
          role="cell"
        >
          <div
            tabindex="0"
            [attr.aria-label]="'Actions for ' + row.displayName"
            class="actions-container"
          >
            <div
              *ngIf="row.nonSpnPatient ? row.allowScheduling : (row.accountComplete && row.allowScheduling)"
              class="row-action"
            >
              <a
                gtagCtaEvent
                [routerLink]="['/scheduling', 'events', 'new']"
                [queryParams]="{ patientId: row.isPatientRecord ? row.id : null }"
                data-test="schedule-session"
                tabindex="0"
              >
                Schedule
              </a>
            </div>
            <div
              *ngIf="showChatLink(row)"
              class="row-action"
            >
              <a
                gtagCtaEvent
                (click)="openChat(row)"
                data-test="non-clinical-chat-link"
                tabindex="0"
              >
                Message
              </a>
            </div>
          </div>
        </mat-cell>
      </ng-container>
!
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns;let i = index;"
      [ngClass]="row.statusClass"
      class="client-list-row"
      [attr.data-test]="'current-client-list-row-' + i">
    </mat-row>
  </mat-table>

  <mat-paginator
    #paginator
    [length]="paginationData?.filtered"
    [pageSize]="tableState?.pageSize"
    [pageIndex]="tableState?.pageIndex"
    [pageSizeOptions]="[15, 30, 50]"
    (page)="onPaginate($event)"
    data-test="current-clients-pagination"
  >
  </mat-paginator>
  </div>
</section>

<div
  class="client-list-empty-state"
  *ngIf="clients.length === 0"
  data-dd-privacy="allow"
>
  <div *ngIf="loadingData.length; else noCurrentClients">
    <iris-icon name="info" [size]="iconSizes.SM" colorToken="$color-dec-indigo-60"></iris-icon>
    {{ loadingData }}
  </div>
</div>

<ng-template #noCurrentClients data-dd-privacy="allow">
  <div *ngIf="!currentClientStore.filterApplied; else filterEmptyState" class="client-list-empty-state-no-clients">
    <ng-container *ngIf="user.acceptingClients || hideAvailability">
      <img src="/assets/images/clients-list/no-matches.svg" alt="">
      <h3>No clients yet</h3>
      <p *ngIf="!hideAvailability">Once you've had your first session, you'll find your client's record here.</p>
      <p>Add clients outside of SonderMind to your caseload with "Invite client."</p>
      <iris-button
      [buttonType]="IrisButtonTypes.SECONDARY"
        (click)="handleNewPatientClick()"
        data-test="current-clients-invite-client"
      >Add client
      </iris-button>
    </ng-container>
    <ng-container *ngIf="!user.acceptingClients && !hideAvailability">
      <img src="/assets/images/clients-list/no-matches-gray.svg" alt="">
      <h3>Update your availability to get matches</h3>
      <p>Add clients outside of SonderMind to your caseload with "Invite client."</p>
      <iris-button
        [routerLink]="['/general_availability']"
        label="Update Availability"
        aria-label="Availability settings"
        data-test="availability-settings"
      >
        Update Availability
      </iris-button>
    </ng-container>
  </div>

  <ng-template #filterEmptyState>
    <div class="client-list-empty-state-no-clients" data-dd-privacy="allow">
      <img src="/assets/images/clients-list/no-search-results-2.svg" alt="">
      <h3>No {{ currentClientStore.filterApplied ? currentClientStore.activeFilter + ' ' : '' }}clients found</h3>
      <p>Try clearing your filters to see more clients.</p>
      <iris-button
      [buttonType]="IrisButtonTypes.PRIMARY"
        (click)="clearFilters()"
        aria-label="Clear filters"
        data-test="clear-all-filters"
      >Clear all filters
      </iris-button>
    </div>
  </ng-template>
</ng-template>

<sondermind-confirmation-modal #deleteConfirmation></sondermind-confirmation-modal>
<sondermind-alert-modal #alertMessage></sondermind-alert-modal>
<embedded-client-creator-dialog #newPatientModal [user]="user"></embedded-client-creator-dialog>
<calendar-bulk-client-upload-dialog #bulkUploadModal [user]="user"></calendar-bulk-client-upload-dialog>
